import { ApiNonAttendeeRegistrationParticipant } from "./types";
import { useGetApiData } from "shared/datalayer";
import FieldViewType from "../../enums/FieldViewType";
import CommonApi from "shared/enums/CommonApi";

export function useGetNonAttendeeRegistration({
  registrationId,
  workEmail,
  viewType,
  successHandler,
  errorHandler,
  ticketFormId
}: {
  registrationId: string;
  workEmail: string;
  viewType?: FieldViewType;
  successHandler: (workEmail: string, regParticipantInfo: ApiNonAttendeeRegistrationParticipant) => void;
  errorHandler: () => void;
  ticketFormId: string;
}) {
  return useGetApiData<ApiNonAttendeeRegistrationParticipant>(
    CommonApi.FIND_NON_ATTENDEE_REGISTRATION,
    {
      params: { registrationId, workEmail, viewType, ticketFormId }
    },
    {
      enabled: Boolean(registrationId) && Boolean(workEmail),
      onSuccess: data => {
        successHandler(workEmail, data);
      },
      onError: () => {
        errorHandler();
      }
    }
  );
}
